<script setup>
import { useI18n } from "vue-i18n"

const { t } = useI18n()

const stats = [
  {
    id: 1,
    name: t("home.stats.stats-value.3-quotes-guarantee.title"),
    value: t("home.stats.stats-value.3-quotes-guarantee.value"),
  },
  {
    id: 2,
    name: t("home.stats.stats-value.installers-in-network.title"),
    value: t("home.stats.stats-value.installers-in-network.value"),
  },
  {
    id: 3,
    name: t("home.stats.stats-value.cost-reduction.title"),
    value: t("home.stats.stats-value.cost-reduction.value"),
  },
  {
    id: 4,
    name: t("home.stats.stats-value.aided-solar-projects.title"),
    value: t("home.stats.stats-value.aided-solar-projects.value"),
  },
]
</script>

<template>
  <div class="">
    <div class="mx-auto max-w-7xl py-12 px-6 lg:px-8">
      <div class="mx-auto max-w-3xl lg:mx-0 lg:max-w-2xl">
        <h2 class="text-base font-semibold">
          <span
            class="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-yellow-400"
            >{{ $t("home.stats.our-track-record") }}</span
          >
        </h2>
        <p
          class="mt-2 text-3xl font-bold tracking-tight text-black sm:text-4xl"
        >
          {{ $t("home.stats.title") }}
        </p>
        <p class="mt-6 text-lg leading-8 text-gray-500">
          {{ $t("home.stats.description") }}
        </p>
      </div>
      <dl
        class="mx-auto mt-8 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-10 sm:mt-16 sm:grid-cols-2 sm:gap-y-12 lg:mx-0 lg:max-w-none lg:grid-cols-4"
      >
        <div
          v-for="stat in stats"
          :key="stat.id"
          class="flex flex-col gap-y-3 border-l border-gray/10 pl-6"
        >
          <dt class="text-sm leading-6 text-gray-700">{{ stat.name }}</dt>
          <dd
            class="order-first text-3xl text-gray-900 font-semibold tracking-tight"
          >
            {{ stat.value }}
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>
